import React, { useState, useEffect, useCallback } from "react";
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import FeatherIcon from "feather-icons-react";
import Breadcrumb from "../../components/Common/Breadcrumb";
import { Link } from "react-router-dom";
import { fetchAllActivitiesWithUsers, fetchUserById, fetchActivitiesByDepartment } from "../../services/activityService";
import { message } from "antd";
import { BASE_URL_IMAGE } from "../../config/api";
import FormattedContentForCards from "../../components/Common/FormattedContentForCards";
import { jwtDecode } from "jwt-decode"; 
import "./ActivityCard.css";
import { encrypt } from "../../utils/encryption";

const ActivityView = () => {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [imageLoadErrors, setImageLoadErrors] = useState({});
  const [userImageErrors, setUserImageErrors] = useState({});




  const [loggedInUserData, setLoggedInUserData] = useState(null);
  console.log(loggedInUserData);

  useEffect(() => {
      const fetchAndSetUser = async () => {
        const token = localStorage.getItem("token");
        if (token) {
          try {
            const decoded = jwtDecode(token);
            const user = await fetchUserById(decoded.id);
            setLoggedInUserData(user);
          } catch (error) {
            console.error("Error decoding token or fetching user:", error);
            localStorage.removeItem("token");
            setLoggedInUserData(null);
          } finally {
            setTimeout(() => setLoading(false), 1000);
          }
        } else {
          setTimeout(() => setLoading(false), 1000);

        }
      };
  
      fetchAndSetUser();
  }, []);





  const breadcrumbItems = [
    { label: "Activities" }
   
  ];

  // const fetchActivities = useCallback(async () => {
  //   try {
  //     const data = await fetchAllActivitiesWithUsers();
  //     const validActivities = data.filter((activity) => activity.user_id && activity.user_id !== 0);
  //     setActivities(validActivities);
  //   } catch (error) {
  //     console.error("Error fetching activities:", error);
  //     message.error("Failed to load activties.");
  //   } finally {
  //     setLoading(false);
  //   }
  // }, []);

  const fetchActivities = useCallback(async () => {
  if (!loggedInUserData) return;

  try {
    let data = [];

    // if (loggedInUserData.user_role === "1") {
      
    //   data = await fetchAllActivitiesWithUsers();
    // } else {
      
    //   data = await fetchActivitiesByDepartment(loggedInUserData.department_id);
    // }
    const role = Number(loggedInUserData.user_role);

    if (role === 1) {
      data = await fetchAllActivitiesWithUsers();
    } else {
      data = await fetchActivitiesByDepartment(loggedInUserData.department_id);
    }


    // ✅ Filter out invalid entries
    const validActivities = data.filter(
      (activity) => activity.user_id && activity.user_id !== 0
    );

    setActivities(validActivities);
  } catch (error) {
    console.error("Error fetching activities:", error);
    message.error("Failed to load activities.");
  } finally {
    setTimeout(() => setLoading(false), 1000);

  }
}, [loggedInUserData]);


  // useEffect(() => {
  //   fetchActivities();
  // }, [fetchActivities]);

  useEffect(() => {
  if (loggedInUserData) {
    fetchActivities();
  }
}, [loggedInUserData, fetchActivities]);


  const handleActivityImageError = (activityId) => {
    setImageLoadErrors((prev) => ({ ...prev, [activityId]: true }));
  };

  const handleUserImageError = (userId) => {
    setUserImageErrors((prev) => ({ ...prev, [userId]: true }));
  };

  const formatDate = (date) => {
    if (!date) return "No Date";
    return new Date(date).toLocaleDateString("en-GB").replace(/\//g, "-");
  };

  const getDuration = (start, end) => {
    if (!start || !end) return "Unknown";
    const diff = (new Date(end) - new Date(start)) / (1000 * 60 * 60 * 24);
    return diff <= 0 ? "1-Day Event" : `${diff + 1}-Day Event`;
  };

  const renderActivityCard = (activity) => {
    const activityImg = imageLoadErrors[activity.event_id]
      ? "/assets/img/blog/blog-01.jpg"
      : `${BASE_URL_IMAGE}/uploads/activityImages/${activity.activity_image}`;
    const userImg = userImageErrors[activity.user_id]
      ? "/assets/img/profiles/avatar-12.jpg"
      : `${BASE_URL_IMAGE}/uploads/userProfiles/${activity.userImage}`;

    return (
      <div className="col-sm-6 col-md-6 col-xl-4 mb-4" key={activity.activity_id}>
        <div className={`evcard ${activity.activity_status == "Active" ? "evcard-active" : "evcard-inactive"}`}>
          <div className="evcard-img-wrapper">
            <img
              src={activityImg}
              alt={activity.activity_title}
              className="evcard-img"
              onError={() => handleActivityImageError(activity.activity_id)}
            />
            <div className="evcard-badges">
              <span className={`evcard-badge ${activity.activity_status == "Active" ? "bg-success" : "bg-secondary"}`}>
                {activity.activity_status == "Active"  ? "ACTIVE" : "INACTIVE"}
              </span>
              <span className="evcard-badge bg-primary">
                {getDuration(activity.activity_start_date, activity.activity_end_date).toUpperCase()}
              </span>
            </div>
          </div>

          <div className="evcard-content">
            <div className="evcard-author">
              <img
                src={userImg}
                alt="author"
                className="evcard-author-img"
                onError={() => handleUserImageError(activity.user_id)}
              />
              <div className="ms-2">
                <h5 className="mb-0 fw-bold">{activity.userName || "Unknown"}</h5>
                <small className="text-muted">{activity.userDesignation || "No Role"}</small>
              </div>
              <div className="ms-auto text-muted d-flex align-items-center">
                <FeatherIcon icon="calendar" size={14} className="me-1" />
                {formatDate(activity.activity_start_date)}
              </div>
            </div>

            <h5 className="fw-bold mt-3 mb-2">{activity.activity_title}</h5>
            <p className="evcard-desc">
              <FormattedContentForCards htmlContent={activity.activity_content} />
            </p>

            <div className="evcard-footer">
              <div>
                <div className="fw-semibold">{activity.activity_conducted_by}</div>
                <div className="text-muted">{activity.activity_mode}</div>
              </div>
              <div className="d-flex gap-2">
                <Link to={`/activity-detail/${encodeURIComponent(encrypt(activity.activity_id))}`} className="btn btn-sm btn-view">
                  View
                </Link>
                <Link to={`/edit-activity/${encodeURIComponent(encrypt(activity.activity_id))}`} className="btn btn-sm btn-edit">
                  Edit
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const activeActivities = activities.filter((e) => e.activity_status === "Active");
  const inactiveActivities = activities.filter((e) => e.activity_status === "Inactive");

  return (
    <div className="main-wrapper">
      <Header />
      <Sidebar id="menu-item-activity" id1="menu-items-activities" activeClassName="blog-grid" />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    
                    <Breadcrumb items={breadcrumbItems} />
                  </li>
                  
                </ul>
              </div>
            </div>
          </div>

          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <div className="row">
              {activeActivities.length > 0 && (
                <div className="col-12 mb-4">
                  <h4 className="text-success fw-bold mb-3">
                    <FeatherIcon icon="check-circle" className="me-2" />
                    Active Activities ({activeActivities.length})
                  </h4>
                  <div className="row">
                    {activeActivities.map(renderActivityCard)}
                  </div>
                </div>
              )}

              {inactiveActivities.length > 0 && (
                <div className="col-12 mt-5">
                  <h4 className="text-muted fw-bold mb-3">
                    <FeatherIcon icon="slash" className="me-2" />
                    Inactive Activities ({inactiveActivities.length})
                  </h4>
                  <div className="row">
                    {inactiveActivities.map(renderActivityCard)}
                  </div>
                </div>
              )}

              {activities.length === 0 && (
                <div className="text-center py-5">
                  <h5>No activities available.</h5>
                  <Link to="/add-activity" className="btn btn-primary mt-2">Create New Activity</Link>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ActivityView;
